import React from 'react'
import { Platform } from 'react-native'

import Box from 'app/components/base/Box'
import Breadcrumbs, {
  BreadcrumbsProps
} from 'app/components/common/Breadcrumbs'

interface ListingContainerProps {
  breadItems?: BreadcrumbsProps['items']
}

const ListingContainer: RFC<ListingContainerProps> = ({
  children,
  breadItems
}) => {
  return (
    <>
      {!!breadItems && (
        <Box
          sx={{
            display: { xs: 'none', md: 'inherit' },
            mb: 2,
            width: '100%',
            maxWidth: 812
          }}
        >
          <Breadcrumbs items={breadItems} isAllLinks />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          ...Platform.select({
            web: {
              flexDirection: { md: 'row', xs: 'column' },
              alignItems: { md: 'flex-start', xs: 'center' },
              paddingBottom: { md: 5, xs: 0 }
            },
            native: {
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: 0
            }
          })
        }}
      >
        {children}
      </Box>
    </>
  )
}

export default ListingContainer
